import { render, staticRenderFns } from "./HolidayPlusRooms.vue?vue&type=template&id=a5e72d4e"
import script from "./HolidayPlusRooms.vue?vue&type=script&lang=js"
export * from "./HolidayPlusRooms.vue?vue&type=script&lang=js"
import style0 from "./HolidayPlusRooms.vue?vue&type=style&index=0&id=a5e72d4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports